/*!
 * jQuery Logo Picker Plugin 0.1.0
 * (not yet public)
 *
 * For internal use at SmileBack, all rights reserved.
 * Copyright 2017.
 *
 * Date: 26-01-2017
 */

(function (factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['jquery', 'core/browser-storage'], function ($, browser_storage) {
      return factory($, browser_storage);
    });
  } else if (typeof module === 'object' && typeof module.exports === 'object') {
    // Node-like environment
    module.exports = factory(require('jquery'), require('core/browser-storage'));
  } else {
    // Browser globals
    factory(window.jQuery, window.browserStorage);
  }
}(function($, browser_storage) {

    var LastLogo = {
        _storage_name: 'logo-last',
        _isEnabled: false,
        _setLastLogo: function(logo) {
            if (logo) {
                browser_storage.setItem(this._storage_name, JSON.stringify(logo));
            } else {
                browser_storage.removeItem(this._storage_name);
            }
        },
        _exists: function(logo) {
            if (!logo) {
                return false;
            }
            if (!Logos) {
                console.log('Missing Logos variable. Cannot determine if saved logo already exists.');
                return false;
            }
            for (i=0; i < Logos.length; i++) {
                var existingLogo = Logos[i];
                if (parseInt(logo.id) === existingLogo.id) {
                    return true;
                }
            }
            return false;
        },
        _displayLastLogo: function(logo) {
            if (logo) {
                if (!this._exists(logo)) {
                    // logo was deleted after saving to browser storage
                    logo = undefined;
                }
                this.setLogoFn(logo);
            }
        },
        _enabled: function() {
            return this._isEnabled;
        },
        setLogoFn: undefined,
        initialize: function(enabled, setLogoFn) {
            this._isEnabled= enabled;
            this.setLogoFn = setLogoFn;

            if (!this._enabled()) {
                // logo storage is disabled
                return;
            }

            var logo = this.getLastLogo();
            this._displayLastLogo(logo);
        },
        save: function(logo) {
            if (!this._enabled() && logo) {
                // logo storage is disabled
                return;
            }

            this._setLastLogo(logo);
        },
        clear: function() {
            this.save(undefined);
        },
        getLastLogo: function() {
            var saved = browser_storage.getItem(this._storage_name);
            if (saved) {
                return JSON.parse(saved);
            }
        }
    };

    $.fn.logoPicker = function(options) {
        var settings = $.extend({
            onSelected: function() {},
            onCleared: function() {}
        }, options);

        var $logo_selection_container = this,
            $button_logo_deselect = $logo_selection_container.find('.button-logo-deselect');

        function setLogo(logo) {
            var $destination_img_container = $logo_selection_container.find('.logo-container'),
                $destination_img = $logo_selection_container.find('img.logo'),
                $destination_title_container = $logo_selection_container.find('.logo-title'),
                $destination_title = $destination_title_container.find('.modal-link-container'),
                $button_logo_select = $logo_selection_container.find('.button-logo-select');

            if (logo) {
                $logo_selection_container.addClass('selected');
                $logo_selection_container.removeClass('unselected');

                $destination_img.addClass('collapse');
                $destination_img.attr('src', logo.src);
                $destination_img.attr('data-logo-id', logo.id);
                $destination_img_container.css('background-image', 'url('+logo.src+')');
                $destination_img_container.removeClass('collapse');

                $destination_title.text(logo.title);
                $destination_title.removeClass('collapse');

                $button_logo_select.attr('title', 'Change Logo');
                $button_logo_deselect.removeClass('collapse');

                LastLogo.save(logo);
            } else {
                $logo_selection_container.removeClass('selected');
                $logo_selection_container.addClass('unselected');

                $destination_img.addClass('collapse');
                $destination_img.removeAttr('src');
                $destination_img.removeAttr('data-logo-id');
                $destination_img_container.css('background-image', 'none');
                $destination_img_container.addClass('collapse');

                $destination_title.text($destination_title_container.attr('data-default-text'));
                $destination_title.removeClass('collapse');

                $button_logo_select.attr('title', 'Choose Logo');
                $button_logo_deselect.addClass('collapse');

                LastLogo.clear();
            }
            notifyCallbacks(logo);
        }

        function notifyCallbacks(logo) {
            if (logo) {
                if ($.isFunction(settings.onSelected())) {
                    settings.onSelected();
                }
            } else {
                if ($.isFunction(settings.onCleared())) {
                    settings.onCleared();
                }
            }
        }

        function chooseLogo() {
            var $container = $(this).parents('.logo-container'),
                img_src = $container.find('img.logo').attr('src'),
                img_title = $container.attr('data-title'),
                logo_id = $container.attr('data-logo-id'),
                $modal = $('#show-logos');

            setLogo({
                id: logo_id,
                src: img_src,
                title: img_title
            });
            $modal.modal('hide');
        }

        function deselectLogo() {
            setLogo();
        }

        function selectedLogo() {
            var $logoImage = $logo_selection_container.find('img.logo'),
                $logoTitle = $logo_selection_container.find('.logo-title');

            if ($logoImage.length == 1 && $logoImage.attr('data-logo-id')) {
                return {
                    id: $logoImage.attr('data-logo-id'),
                    src: $logoImage.attr('src'),
                    title: $logoTitle.text()
                }
            }
            return LastLogo.getLastLogo();
        }

        $('#logos-content .choose-logo').on('click', chooseLogo);
        $('#logos-content .image-container').on('click', chooseLogo);
        $button_logo_deselect.on('click', deselectLogo);
        LastLogo.initialize($logo_selection_container.data('rememberSelection'), setLogo);

        return {
            selectedLogoId: function() {
                var logo = selectedLogo();
                if (logo) {
                    return logo.id;
                }
            }
        }

    }
}));
